/**
 * Remote control settings plugin.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    rcEnable, rcDeviceName, rcPassword, _;


/**
 * Save settings.
 *
 * @param {Object} app - API container
 */
function saveSettings ( app ) {
    var errors   = [],
        setItems = function () {
            gSTB.ConfigNetRc(rcDeviceName, rcPassword);
            gSTB.SetNetRcStatus(rcEnable);

            app.storage.setItem('rcEnable', rcEnable);
            app.storage.setItem('rcDeviceName', rcDeviceName);
            app.storage.setItem('rcPassword', rcPassword);
        };

    if ( rcEnable ) {
        if ( !rcDeviceName ) {
            errors.push(_('Device name'));
        }

        if ( !rcPassword ) {
            errors.push(_('Password'));
        }

        if ( errors.length ) {
            core.notify({
                title: _('The following fields have been completed incorrectly.') + ': ' + errors.join(', '),
                icon: 'alert',
                type: 'error'
            });
        } else {
            setItems();
        }
    } else {
        setItems();
    }
}


module.exports = {
    onInit: function ( app, callback ) {
        rcEnable     = app.storage.getItem('rcEnable')     === undefined ? false : app.storage.getItem('rcEnable');
        rcDeviceName = app.storage.getItem('rcDeviceName') === undefined ? ''    : app.storage.getItem('rcDeviceName');
        rcPassword   = app.storage.getItem('rcPassword')   === undefined ? ''    : app.storage.getItem('rcPassword');

        if ( rcEnable ) {
            gSTB.ConfigNetRc(rcDeviceName, rcPassword);
            gSTB.SetNetRcStatus(rcEnable);
        }

        callback();
    },
    onSettingsInit: function ( app, callback ) {
        var api = app.api;

        gettextWrapper.load({
            name: core.environment.language,
            path: app.path + 'lang'
        }, function () {
            _ = gettextWrapper.gettext;

            callback(null, {
                id: 'remoteControl',
                name: _('Remote control'),
                // eslint-disable-next-line
                description: _('The Remote control function allows you to connect devices to the set-top box remotely (for example, a mobile phone with installed MAGic Remote App)'),
                icon: 'theme-icon theme-icon-rc',
                sections: [
                    {
                        id: 'remoteControl',
                        name: _('Remote control'),
                        // eslint-disable-next-line
                        description: _('The Remote control function allows you to connect devices to the set-top box remotely (for example, a mobile phone with installed MAGic Remote App)'),
                        icon: 'theme-icon theme-icon-rc',
                        parent: 'system'
                    }
                ],
                options: [
                    {
                        id: 'rcEnable',
                        name: _('Enable remote control'),
                        description: _('Enable remote control function'),
                        icon: 'theme-icon theme-icon-rc',
                        render: api.renders.toggle,
                        saveImmediate: true,
                        data: {
                            rcEnable: rcEnable
                        },
                        prepareForRender: function ( value, prepareCallback ) {
                            prepareCallback(!!value.rcEnable);
                        },
                        prepareForSave: function ( value, prepareCallback ) {
                            this.data.rcEnable = rcEnable = value;
                            saveSettings(app);
                            prepareCallback();
                        },
                        parent: 'remoteControl'
                    },
                    {
                        id: 'rcDeviceName',
                        name: _('Device name'),
                        // eslint-disable-next-line
                        description: _('Enter the device name (for example, when you start the MAGic Remote application on your mobile device, you will need to select a device with the given name from the list)'),
                        icon: 'theme-icon theme-icon-edit',
                        render: api.renders.input,
                        config: {
                            type: 'qwerty'
                        },
                        saveImmediate: true,
                        data: {
                            rcDeviceName: rcDeviceName
                        },
                        prepareForRender: function ( value, prepareCallback ) {
                            prepareCallback(value.rcDeviceName);
                        },
                        prepareForSave: function ( value, prepareCallback ) {
                            this.data.rcDeviceName = rcDeviceName = value;
                            saveSettings(app);
                            prepareCallback();
                        },
                        parent: 'remoteControl'
                    },
                    {
                        id: 'rcPassword',
                        name: _('Password'),
                        // eslint-disable-next-line
                        description: _('Enter the password (for example, this password will be requested by the MAGic Remote application after selecting the device from the list)'),
                        icon: 'theme-icon theme-icon-lock',
                        render: api.renders.input,
                        config: {
                            type: 'password'
                        },
                        saveImmediate: true,
                        data: {
                            rcPassword: rcPassword
                        },
                        prepareForRender: function ( value, prepareCallback ) {
                            prepareCallback(value.rcPassword);
                        },
                        prepareForSave: function ( value, prepareCallback ) {
                            this.data.rcPassword = rcPassword = value;
                            saveSettings(app);
                            prepareCallback();
                        },
                        parent: 'remoteControl'
                    }
                ]
            });
        });
    }
};
